import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const OverPaymentChart = ({ data }) => {
  // Aggregate by zone
  const zones = [ "zone2", "zone4"];
  const chartData = zones.map((zone) => {
    const zoneData = data.filter((item) => item.zoneId === zone);
    const totalUnits = zoneData.length;
    const totalPayment = zoneData.reduce(
      (acc, item) => acc + item.payment,
      0
    );
    const totalChargeArrears = zoneData.reduce(
      (acc, item) => acc + item.rentalCharge + item.arrears,
      0
    );
    const overpayment = totalPayment - totalChargeArrears;

    // Percentage relative to max overpayment for chart
    const percent =
      totalChargeArrears > 0 ? Math.round((totalPayment / totalChargeArrears) * 100) : 0;

    // Count pass/not-pass
    const passCount = zoneData.filter((item) => item.dblkStatus === "pass").length;
    const passPercent = totalUnits > 0 ? Math.round((passCount / totalUnits) * 100) : 0;

    return {
      zone,
      overpaymentPercent: percent,
      totalOverpayment: overpayment,
      passPercent,
      failPercent: 100 - passPercent,
    };
  });

  return (
    <div className="w-full bg-white shadow-lg rounded-xl p-5">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Overpayment by Zone
      </h2>

      <ResponsiveContainer width="100%" height={320}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 20, left: 10, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" className="stroke-gray-300" />
          <XAxis dataKey="zone" className="text-sm" />
          <YAxis tickFormatter={(v) => `${v}%`} className="text-sm" />
          <Tooltip
            formatter={(value, key, props) => {
              if (key === "overpaymentPercent")
                return [`${value}%`, "Overpayment %"];
              if (key === "totalOverpayment")
                return [`RM ${props.payload.totalOverpayment.toLocaleString()}`, "Amount"];
              if (key === "passPercent")
                return [`${value}%`, "Pass %"];
            }}
          />

          {/* Overpayment % Bar */}
          <Bar
            dataKey="overpaymentPercent"
            barSize={40}
            fill="#2563eb"
            radius={[5, 5, 0, 0]}
          />

          {/* Pass % Bar */}
          <Bar
            dataKey="passPercent"
            barSize={40}
            fill="#16a34a"
            radius={[5, 5, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OverPaymentChart;
